import moment from "moment";
import { genesis, revelation } from "./messages";
import { READING_ORDERS } from "utils/readingOrders";

export const initialStartReading = {
  bookIndex: 0,
  chapter: 1,
  bibleReference: `${genesis} 1`,
};

export const initialEndReading = {
  bookIndex: 65,
  chapter: 22,
  bibleReference: `${revelation} 22`,
};

const bibleArrayChronological = READING_ORDERS.chronological;
const bibleArray = READING_ORDERS.traditional;
const bibleArrayHistorical = READING_ORDERS.historical;

export const INITIAL_END_READING_BY_READING_ORDER = {
  traditional: {
    bookIndex: bibleArray.length - 1,
    chapter: bibleArray[bibleArray.length - 1].endChapter,
    bibleReference: `${bibleArray[bibleArray.length - 1].bookAbbreviation} ${
      bibleArray[bibleArray.length - 1].endChapter
    }`,
  },
  chronological: {
    bookIndex: bibleArrayChronological.length - 1,
    chapter:
      bibleArrayChronological[bibleArrayChronological.length - 1].endChapter,
    bibleReference: `${
      bibleArrayChronological[bibleArrayChronological.length - 1]
        .bookAbbreviation
    } ${
      bibleArrayChronological[bibleArrayChronological.length - 1].endChapter
    }`,
  },
  historical: {
    bookIndex: bibleArrayHistorical.length - 1,
    chapter: bibleArrayHistorical[bibleArrayHistorical.length - 1].endChapter,
    bibleReference: `${
      bibleArrayHistorical[bibleArrayHistorical.length - 1].bookAbbreviation
    } ${bibleArrayHistorical[bibleArrayHistorical.length - 1].endChapter}`,
  },
};

export const INITIAL_START_READING_BY_READING_ORDER = {
  traditional: {
    bookIndex: 0,
    chapter: bibleArray[0].startChapter,
    bibleReference: `${bibleArray[0].bookAbbreviation} ${bibleArray[0].startChapter}`,
  },
  chronological: {
    bookIndex: 0,
    chapter: bibleArrayChronological[0].startChapter,
    bibleReference: `${bibleArrayChronological[0].bookAbbreviation} ${bibleArrayChronological[0].startChapter}`,
  },
  historical: {
    bookIndex: 0,
    chapter: bibleArrayHistorical[0].startChapter,
    bibleReference: `${bibleArrayHistorical[0].bookAbbreviation} ${bibleArrayHistorical[0].startChapter}`,
  },
};

export const today = moment();

export const todayMorning = () => {
  const year = moment().year();
  const month = moment().month();
  const date = moment().date();

  const earliest = moment([year, month, date]).startOf("day");

  return earliest;
};

export const lastDayInYear = moment([moment().year(), 11, 31]);
